export default "__VITE_ASSET__BMH1Yhlh__"